import { Fragment, type FC } from 'react';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { type AuditFormLightingTypeEntryPageViewModel } from './audit-form-lighting-type-entry-page.view-model';
import { AuditFormLightingTypeEntryPageRenderer } from './audit-form-lighting-type-entry-page.renderer';
import { DeleteConfirmationDialog } from '#packages/web/layouts/dialog/templates/delete-confirmation';

export type AuditFormLightingTypeEntryPageContainerProps =
  ViewModelProps<AuditFormLightingTypeEntryPageViewModel> & LoggingContext;

export const AuditFormLightingTypeEntryPageContainer: FC<
  AuditFormLightingTypeEntryPageContainerProps
> = ({ viewModel }) => {
  const {
    loadAuditFormState,
    updateMutationState,
    form,
    deleteDialog,
    onDelete,
    onSubmit,
  } = viewModel;

  return (
    <Fragment>
      {loadAuditFormState.state === 'loading' && <LoadingPage />}

      {loadAuditFormState.state === 'success' && (
        <AuditFormLightingTypeEntryPageRenderer
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {loadAuditFormState.state === 'error' && (
        <ThrowError error={loadAuditFormState.error} />
      )}

      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}

      {deleteDialog.isOpen && (
        <DeleteConfirmationDialog
          open
          onCancel={deleteDialog.close}
          onConfirm={onDelete.bind(null, { confirmed: true })}
        />
      )}
    </Fragment>
  );
};
